import React from "react";
import { useIntl } from "react-intl";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { TableCellProps, CellAlignment } from "../types";
import { titleCellClass } from "../TableQuestion.css";

export interface TitleCellProps
  extends Pick<TableCellProps, "cellId" | "text" | "colspan"> {
  bgColor?: string;
  align?: CellAlignment;
}

export const TitleCell: React.FC<TitleCellProps> = ({
  cellId,
  text,
  colspan,
  bgColor,
  align,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const style: React.CSSProperties = {
    ...(bgColor && { backgroundColor: bgColor }),
    ...(align && { textAlign: align }),
  };

  return (
    <th
      key={cellId}
      className={titleCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
      scope="col"
      style={style}
    >
      <RichText value={translatedText} />
    </th>
  );
};
